var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contactImg)?_c('div',{staticClass:"contact"},[_c('img',{attrs:{"src":_vm.contactImg}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }